<template>
    <v-content-layout>
        <template #header>
            <el-button size="small" type="primary" @click="() => $router.push('/invoice-records')">Back</el-button>
            <div>
				<el-input size="small" class="ml-2" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
			</div>
            <v-spacer></v-spacer>
            <span class="subtitle-1 mr-2" v-if="$route.query.invoiceNo">Invoice No. {{ $route.query.invoiceNo }}</span>
            <span class="mr-2" v-if="$route.query.purchaseOrderNumber !== 'undefined'">|</span>
            <span class="subtitle-1 mr-2" v-if="$route.query.purchaseOrderNumber !== 'undefined'">PO No. {{ $route.query.purchaseOrderNumber }}</span>
            <v-export-table
            text="Export"
            :tableColumns="tableColumns"
            :tableData="items"
            :filename="`Invoice-No-${$route.query.invoiceNo}-${Date.now()}`"
            :filesheet="`Invoice-No-${$route.query.invoiceNo}`"
            ></v-export-table>
        </template>

        <template #body>
            <e-table :data="items" :total="items.length" :search="search" :headers="updatedHeader" :height="window.height - 170"></e-table>
        </template>
    </v-content-layout>
</template>

<script>
export default {
    data: () => ({
        headers: [
            {
                text: 'DD SKU',
                value: 'ddSku',
                sortable: true,
                width: '200'
            },
            {
                text: 'DD Cost',
                value: 'ddCost',
                sortable: true,
                width: '150'
            },
            {
                text: 'DD Qty',
                value: 'ddQty',
                sortable: true,
                width: '150'
            },
            {
                text: 'SKU Status',
                value: 'skuStatus',
                sortable: true,
                width: '150',
                formatter: row => `${row.skuStatus ?  'TRUE' : 'FALSE'}`
            },
            {
                text: 'Cost Status',
                value: 'costStatus',
                sortable: true,
                width: '150',
                formatter: row => `${row.costStatus ?  'TRUE' : 'FALSE'}`
            },
            {
                text: 'Qty Status',
                value: 'qtyStatus',
                sortable: true,
                width: '150',
                formatter: row => `${row.qtyStatus ?  'TRUE' : 'FALSE'}`
            },
            {
                text: 'SKU',
                value: 'SKU',
                sortable: true,
                width: '200'
            },
            {
                text: 'Ordered Qty',
                value: 'orderedQty',
                sortable: true,
                width: '150'
            },
            {
                text: 'Shipped Qty',
                value: 'shippedQty',
                sortable: true,
                width: '150'
            },
            {
                text: 'Item Cost',
                value: 'itemCost',
                sortable: true,
                width: '150'
            },
            {
                text: 'Disc Cost',
                value: 'discountedCost',
                sortable: true,
                width: '150'
            },
            {
                text: 'Bt Cost',
                value: 'btCost',
                sortable: true,
                width: '150'
            },
            {
                text: 'Total Price',
                value: 'totalPrice',
                sortable: true,
                width: '150'
            },
            {
                text: 'Discrepancy',
                value: 'discrepancyChecker',
                sortable: true,
                width: '150'
            },
            {
                text: 'Matched?',
                value: 'isMatched',
                sortable: true,
                width: '150',
                formatter: row => `${row.isMatched ?  'TRUE' : 'FALSE'}`
            },
        ],
        updatedHeader: [],
        items: [],
        tableColumns: [],
        tableData: [],
        search: ''
    }),
    created() {
        this.loadInvoiceItems(this.$route.query.itemId);
    },
    methods: {
        async loadInvoiceItems(itemId){
            this.$Progress.start()
            try {
                let response = await this.$http.get(`/get/invoice-data?itemId=${itemId}`);
                if(response.data.length === 0){
                    this.$Progress.fail()
                    this.$router.push('/invoice-records')
                }else{
                    this.items = response.data.map(e => {
                        let skuStatus = e.ddSku === e.SKU ? true : false;
                        let costStatus = e.ddCost === e.discountedCost ? true : false;
                        let qtyStatus = e.ddQty === e.orderedQty ? true : false;
                        let SKU = e.SKU === 'dummySKU' ? '' : e.SKU;

                        return {
                            ...e,
                            SKU,
                            skuStatus,
                            costStatus,
                            qtyStatus
                        }
                    })
                    let countItemCost = this.items.filter(e => e.itemCost > 0)
                    if(countItemCost.length === 0){
                        this.headers =  this.headers.filter(header => header.value !== 'itemCost')
                    }else{
                        this.headers =  this.headers.filter(header => header.value !== 'discountedCost')
                    }

                    if(this.$route.query.invoiceType === 'MFN' || this.$route.query.invoiceType === 'fileFeed'){
                        this.updatedHeader = this.headers.filter(header =>
                            header.value !== 'ddSku' && header.value !== 'ddCost' && header.value !== 'ddQty' &&
                            header.value !== 'skuStatus' && header.value !== 'costStatus' && header.value !== 'qtyStatus'
                        )
                        this.tableData = this.items.filter(item =>
                            item !== 'ddSku' && item !== 'ddCost' && item !== 'ddQty' &&
                            item !== 'skuStatus' && item !== 'costStatus' && item !== 'qtyStatus'
                        )
                    }else{
                        this.tableData = this.items
                        this.updatedHeader = this.headers.filter(header => header.value !== 'discrepancyChecker' &&  header.value !== 'isMatched' && header.value !== 'itemCost')
                    }
                    this.tableColumns = this.updatedHeader.map(e => {
                        return{
                            label: e.text,
                            field: e.value
                        }
                    })
                    this.$Progress.finish();
                }
            } catch (error) {
                this.$toast.open({
                    type: 'error',
                    message: error.data.err.msg
                })
            }
        }
    }
}
</script>